import { connect } from 'react-redux';
import Error from '../components/views/Error';

const mapStateToProps = (state) => {
	return {
		price: state.calculatorData.initial.price
	};
};

export default connect(mapStateToProps)(Error);
